<template>
	<div>
		
		<!-- confirmation dialog box -->
		<v-dialog v-model="dialog.flag" width="400"  persistent >
			<v-card>
				<div>
					<p class="text-right pr-3" style="margin-bottom:-10px !important">
						<v-icon color="#8F8F8F" small
						@click="closeDialog">
						mdi-window-close
					</v-icon>
				</p>

				<p class="page-title text-center">{{$lang.PAYMENT_LINK.toUpperCase()}}</p>
			</div >
			<v-card-text class="flex-column text-center px-7">
				<p class="secondary-text my-2">
					Help text here
				</p>
				<textarea  rows="3" cols="35" type="text" class="border-a pa-2" :value="url" id="myInput" readonly />
				<div   class="text-center">
					<v-btn color="primary" width="80" class="fw-bold mt-5" @click="copyText" >
						Copy
					</v-btn>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</div>
</template>
<script>
export default{
	props:['dialog','url'],
	data(){
		return{
			btn_loading:false,
		}
	},
	methods:{
		copyText() {
			var copyText = document.getElementById("myInput");
			copyText.select();
			copyText.setSelectionRange(0, 99999)
			document.execCommand("copy");
		},
		closeDialog(){
			this.dialog.flag=false;
			this.$router.push({name:"user-subscriptions"})
		}
		
	}
}

</script>